/*
 * @Author: Chao Yang
 * @Date: 2019-12-16 04:11:15
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-07-29 03:04:43
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as Configruation from 'src/app/domain/model/configuration';
import * as Document from 'src/app/domain/model/document';
import { IDropDownBase } from 'src/app/domain/model/i-drop-down-base.model';
import { BaseProxy } from '../base.proxy';
import {
  IDashboardReadUnreadDateConfig,
  IDashboardReadUnreadOrderTypeConfig,
} from 'src/app/domain/model/document';
import { environment } from 'src/environments/environment';

@Injectable()
export class PreferenceProxy extends BaseProxy {
  createDocumentCenterConfiguration(
    configuration: Document.IConfiguration
  ): Observable<void> {
    return this._http.post<void>(
      '/ip/api/preference/documentcenter/configuration',
      configuration
    );
  }

  getAccountDetailConfiguration(): Observable<Document.IConfiguration> {
    return this._http.get<Document.IConfiguration>(
      '/ip/api/preference/accountdetail/configuration'
    );
  }

  getAccountDetailActivityLastCheckDate(programId: number): Observable<number> {
    return this._http.get<number>(
      '/ip/api/preference/program/' +
      programId +
      '/account/detail/activity/configuration/date'
    );
  }

  getDashboardOfferingOpenClosedDataSource(): Observable<IDropDownBase[]> {
    return this._http.get<IDropDownBase[]>(
      '/ip/api/dashboard/offering/datasource/openclosed'
    );
  }

  getDashboardOfferingOpenClosedConfiguration(): Observable<
    Configruation.IConfiguration<number>
  > {
    return this._http.get<Configruation.IConfiguration<number>>(
      '/ip/api/preference/dashboard/offering/configuration/openclosed'
    );
  }

  getDashboardOfferingSortConfiguration(): Observable<
    Configruation.IConfiguration<string>
  > {
    return this._http.get<Configruation.IConfiguration<string>>(
      '/ip/api/preference/dashboard/offering/configuration/sort'
    );
  }

  getDocumentCenterConfiguration(): Observable<Document.IConfiguration> {
    return this._http.get<Document.IConfiguration>(
      '/ip/api/preference/documentcenter/configuration'
    );
  }

  updateAccountDetailActivityLastCheckDate(
    programId: number,
    lastDate: Date
  ): Observable<void> {
    return this._http.put<void>(
      '/ip/api/preference/program/' +
      programId +
      '/account/detail/activity/configuration/date/' +
      lastDate.getTime(),
      undefined
    );
  }

  updateDocumentCenterConfiguration(
    configuration: Document.IConfiguration
  ): Observable<void> {
    return this._http.put<void>(
      '/ip/api/preference/documentcenter/configuration',
      configuration
    );
  }

  createDashboardDocumentDateConfig(
    configuration: Document.IDashboardReadUnreadDateConfig
  ) {
    return this._http.post<any>(
      `/ip/api/preference/dashboard/document/configuration/date`,
      configuration
    );
  }

  createDashboardOfferingOpenClosedConfig(
    configuration: Document.IDashboardReadUnreadDateConfig
  ) {
    return this._http.post<any>(
      `/ip/api/preference/dashboard/offering/configuration/openclosed`,
      configuration
    );
  }

  updateDashboardDocumentDateConfig(
    configuration: Document.IDashboardReadUnreadDateConfig
  ) {
    return this._http.put<any>(
      `/ip/api/preference/dashboard/document/configuration/date`,
      configuration
    );
  }

  updateDashboardOfferingOpenClosedConfig(
    configuration: Document.IDashboardReadUnreadDateConfig
  ) {
    return this._http.put<any>(
      `/ip/api/preference/dashboard/offering/configuration/openclosed`,
      configuration
    );
  }

  getDashboardDocumentDateConfig() {
    return this._http.get<IDashboardReadUnreadDateConfig>(
      `/ip/api/preference/dashboard/document/configuration/date`
    );
  }

  createDashboardDocumentSortConfig(
    configuration: Document.IDashboardReadUnreadOrderTypeConfig
  ) {
    return this._http.post<any>(
      `/ip/api/preference/dashboard/document/configuration/sort`,
      configuration
    );
  }

  createDashboardOfferingSortConfig(
    configuration: Document.IDashboardReadUnreadOrderTypeConfig
  ) {
    return this._http.post<any>(
      `/ip/api/preference/dashboard/offering/configuration/sort`,
      configuration
    );
  }

  updateDashboardDocumentSortConfig(
    configuration: Document.IDashboardReadUnreadOrderTypeConfig
  ) {
    return this._http.put<any>(
      `/ip/api/preference/dashboard/document/configuration/sort`,
      configuration
    );
  }

  updateDashboardOfferingSortConfig(
    configuration: Document.IDashboardReadUnreadOrderTypeConfig
  ) {
    return this._http.put<any>(
      `/ip/api/preference/dashboard/offering/configuration/sort`,
      configuration
    );
  }

  getDashboardDocumentSortConfig() {
    return this._http.get<IDashboardReadUnreadOrderTypeConfig>(
      `/ip/api/preference/dashboard/document/configuration/sort`
    );
  }

  getDataSource() {
    if (environment.feature.newApi === false) {
      return this._http.get<string>(`/ip/api/preference/datasource`);
    } else {
      return this._http.get<string>(`/ip-api/api/preference/datasource`);
    }
  }

  setDraftDS() {
    if (environment.feature.newApi === false) {
      return this._http.put(`/ip/api/preference/datasource/draft`, {});
    } else {
      return this._http.put(`/ip-api/api/preference/datasource/draft`, {});
    }
  }

  setPublishedDS() {
    if (environment.feature.newApi === false) {
      return this._http.put(`/ip/api/preference/datasource/published`, {});
    } else {
      return this._http.put(`/ip-api/api/preference/datasource/published`, {});
    }
  }

  setGlobalCurrency(globalCurrency: string) {
    return this._http.put(`/ip/api/preference/currency/default/` + globalCurrency, {})
  }
}
